<template>
  <div class="row">
    <Aguarde :show="httpSend"></Aguarde>
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <form-wizard ref="tabNota" next-button-text="Próximo" back-button-text="Anterior" color="#556ee6">

            <tab-content :before-change="validaTabTomador" title="Tomador" icon="bx bx-user">
              <tab-tomador
                  ref="tabTomadorRef"
                  :tomador="tomador"
                  :pais-tomador.sync="pais_tomador.pais"
                  :substituicao="substituicao"
                  :ranfs="ranfs"
                  :cpf-cnpj-invalid="cpfCnpjInvalid"
                  :tomador-is-prestador="tomadorIsPrestador"
                  :error-cep="errorCepTomador"
                  :submitted="submitted"
                  :erro-razao-social="pais_tomador.erro_razao_social"
                  :erro-endereco="pais_tomador.erro_endereco"
                  :validation="tomadorValidation"
                  @open-modal-copiar="openModalCopiar"
                  @loc-tomador="locTomador"
                  @loc-cep="locCEP"
                  @alter-pais="onAlterPais"/>
            </tab-content>

            <tab-content :before-change="validaTabServico" :lazy="true" title="Serviços" icon="bx bx-wrench">
              <tab-servicos
                  ref="tabServicosRef"
                  :servico="servico"
                  :competencia="competencia"
                  :entidade="entidade"
                  :ranfs="ranfs"
                  :substituicao="substituicao"
                  :is-avulso="isAvulso"
                  :is-obra="isObra"
                  :cnae-aux.sync="cnae_aux"
                  :list-atividades="list_atividades"
                  :list-cnae="list_cnae"
                  :list-nbs="list_nbs"
                  :list-operacao="list_operacao"
                  :list-classificacao="list_classificao"
                  :meses="meses"
                  :verifica-tributacao="verificaTributacao"
                  :descricao-favorito.sync="descricaoFavorito"
                  :dsf-codigo="descricaoFavoritaDados.dsf_codigo"
                  :http-send-salva-favorito="httpSendSalvaFavorito"
                  :error-cep-obra="errorCepObra"
                  :submitted="submitted"
                  :validation="servicoValidation"
                  @alter-ano="alter_ano"
                  @select-atividade="selctAtividade"
                  @select-tributacao="selctTributacao"
                  @pesquisar-cnae="pesquisarCnaeRanfs"
                  @pesquisar-servicos="pesquisarServicosRanfs"
                  @reseta-obra="resetaObra"
                  @loc-obra="locObra"
                  @open-modal-descricoes="openModalHistoricoDescricoes"
                  @save-descricao-favorito="saveDescricaoFavorito"/>
            </tab-content>

            <tab-content :before-change="validaTabValores" :lazy="true" title="Valores" icon="bx bx-dollar">
              <tab-valores
                  :valores="valores"
                  :verifica-aliquota="verificaAliquota"
                  :verifica-deducao="verificaDeducao"
                  :verifica-retencao="verificaRenetencao"
                  :is-avulso="isAvulso"
                  :is-tomador-c-n-p-j="isTomadorCNPJ"
                  :sep-iss="sep_iss"
                  :retencao-federal="retencao_federal"
                  :valor-liquido="valor_liquido"
                  :valor-i-s-s-negativo="valorISSNegativo"
                  :valor-liquido-negativo="valorLiquidoNegativo"
                  :inss-avulso="inss_avulso"
                  :irrf-avulso="irrf_avulso"
                  :inss-base-acumulado="inss_base_acumulado"
                  :inss-mensal="inss_mensal"
                  :inss-ja-retido="inss_ja_retido"
                  :inss-valor-desta="inss_valor_desta"
                  :validation="valoresValidation"
                  @alter-retencao="alterRentencao"/>
            </tab-content>

            <tab-content title="Emissão" :lazy="true" icon="bx bx-check-double">
              <tab-emissao
                  :tomador="tomador"
                  :servico="servico"
                  :competencia="competencia"
                  :valores="valores"
                  :substituindo="substituindo"
                  :is-estrangeiro="isEstrangeiro"
                  :ranfs="ranfs"
                  :sep-iss="sep_iss"
                  :retencao-federal="retencao_federal"
                  :valor-liquido="valor_liquido"/>
            </tab-content>

            <template #footer="props">
              <div class="wizard-footer-left">
                <wizard-button v-if="props.activeTabIndex > 0" @click.native="props.prevTab()"
                               :style="props.fillButtonStyle"><i class="fas fa-arrow-left"></i> Anterior
                </wizard-button>
              </div>
              <div class="wizard-footer-right">
                <wizard-button v-if="!props.isLastStep" @click.native="props.nextTab()" class="wizard-footer-right"
                               :style="props.fillButtonStyle">Próximo <i class="fas fa-arrow-right"></i>
                </wizard-button>
                <button v-if="!ranfs && props.isLastStep && !isAvulso" type="button"
                        @click="confirmacao(0)"
                        class="wizard-footer-right btn btn-label btn-success"><i
                    class="bx bx-check-double label-icon"></i>
                  <span v-if="substituicao">Confirmar substituição da nota</span>
                  <span v-else>Emitir nota fiscal</span>
                </button>
                <button v-if="!ranfs && props.isLastStep && isAvulso" type="button"
                        @click="confirmacaoAvulsa(0)"
                        class="wizard-footer-right btn btn-label btn-success"><i
                    class="bx bx-check-double label-icon"></i>
                  Emitir nota fiscal avulsa
                </button>
                <button v-if="ranfs && props.isLastStep" type="button" @click="confirmacaoRanfs()"
                        class="wizard-footer-right btn btn-label btn-success"><i
                    class="bx bx-check-double label-icon"></i>
                  Emitir Ranfs
                </button>
              </div>
            </template>
          </form-wizard>
        </div>
      </div>
    </div>

    <!-- Modais -->
    <modal-copiar-nota
        ref="modalCopiarNota"
        :ultima-nota="copyNota.ultima_nota"
        :loading="httpSendPesquisaCopyNota"
        :eco-codigo="empresa.eco_codigo"
        @selecionar="selecionaUltimaNota"
        @pesquisar="pesquisarUltimaNotas"
        @hidden="onModalHidden('copyAnterior')"/>

    <modal-descricoes-favoritas
        ref="modalDescricoes"
        :lista="descricaoFavoritaDados.lista"
        :loading="httpSendPesquisaCopyNota || httpSendSalvaFavorito"
        @selecionar="selecionarDescricaoFavorito"
        @remover="confirmacaoRemoverFavorito"
        @hidden="onModalHidden('descricaoFav')"/>
  </div>
</template>

<script>
import {VMoney} from 'v-money'
import Aguarde from "@/components/widgets/aguarde";
import {FormWizard, TabContent, WizardButton} from "vue-form-wizard";
import {required, minValue, maxValue, minLength, maxLength, requiredIf} from "vuelidate/lib/validators";
import Swal from "sweetalert2";
import {getCEP} from "@/api/externa/cep";
import {getAtividadeCnae, getBaseMensal, getComplementoServico, getPrestador, getTomador} from "@/api/core/pessoa";
import {autocompleteCnae, autocompleteServicos} from "@/api/geral/autocomplete";
import moment from "moment";
import {gerarNota, getNotaFiscal, getNotaFiscalTributacaoSimples} from "@/api/nfse/nota";
import {
  arredondamento, isCnpj, listMeses, validaCpfCnpj,
  getFimMesDate, naCompetencia, validarTelefoneBR, isMobile, validarEmail
} from "@/helps/util";
import {gerarNotaAvulsa} from "@/api/nfse/nota_avulsa";
import {notifyAviso, notifyErro} from "@/helps/notificacao";
import store from "@/state/store";
import {locEmpresa} from "@/api/externa/apiExt";
import {nextTick} from "vue";
import {round} from "echarts/lib/util/number";
import {solicitarRanfs} from "@/api/ranfs/ranfs";
import {impressao} from "@/helps/impressao";
import {setRelRanfs} from "@/api/relatorio/ranfs";

const {notifySucesso} = require("@/helps/notificacao");
const {
  getEnviaEmailNotaFiscal, listNotas,
  deleteDescricaoFavorita, saveDescricaoFavorita, listDescricaoFavorita
} = require("@/api/nfse/nota");

// Subcomponentes
import TabTomador from './TabTomador.vue'
import TabServicos from './TabServicos.vue'
import TabValores from './TabValores.vue'
import TabEmissao from './TabEmissao.vue'
import ModalCopiarNota from './ModalCopiarNota.vue'
import ModalDescricoesFavoritas from './ModalDescricoesFavoritas.vue'

export default {
  name: "nota-fiscal",
  components: {
    Aguarde, FormWizard, TabContent, WizardButton,
    TabTomador, TabServicos, TabValores, TabEmissao,
    ModalCopiarNota, ModalDescricoesFavoritas,
  },
  directives: {money: VMoney},
  props: {
    substituicao: {type: Boolean, default: false},
    ranfs: {type: Boolean, default: false},
  },
  data() {
    return {
      httpSend: false,
      httpSendPesquisaCopyNota: false,
      httpSendSalvaFavorito: false,
      meses: [],
      list_atividades: [],
      list_cnae: [],
      list_nbs: [],
      list_operacao: [],
      list_classificao: [],
      isAvulso: false,
      isTomadorCNPJ: false,
      isObra: false,
      cpfCnpjInvalid: false,
      tomadorIsPrestador: false,
      descricaoFavorito: false,
      substituindo: {not_hash: null, not_numero: null},
      copyNota: {
        ultima_nota: [],
        filtro: {nota_pagina: 1, not_emissao_ano: moment().format('YYYY'), not_numero: null},
        resultado_pesquisa: null,
      },
      pais_tomador: {pais: 'BR', erro_razao_social: false, erro_endereco: false},
      tomador: {
        sep_cpf_cnpj_tomador: '', sep_nif_tomador: '', sep_razao_social_tomador: '',
        sep_inscricao_municipal_tomador: '', sep_inscricao_estadual_tomador: '',
        sep_endereco_tomador: '', sep_numero_endereco_tomador: '',
        sep_complemento_endereco_tomador: '', sep_bairro_tomador: '',
        sep_municipio_tomador: '', sep_cep_tomador: '', sep_telefone_tomador: '',
        pas_codigo: '', eco_substituicao: '',
      },
      cnae_aux: null,
      servico: {
        sep_competencia: "", sep_exigibilidade_iss: "1", sep_tributacao_iss: "1",
        sep_municipio_incidencia: {mun_codigo: "", mun_nome: "", mun_uf: ""},
        sep_municipio_prestacao: {mun_codigo: "", mun_nome: "", mun_uf: ""},
        ran_numero: "", ran_nota_emissao: "", ran_not_nsu: "",
        ser_codigo: "", cnae_codigo: "", sep_discriminacao: "", sep_data_tributacao: "",
        nbs_codigo: "", iop_codigo: "", cst_classtrib: "", ser_incidencia: "",
        obra: {
          sep_obra_tipo: null, sep_obra_insc_fiscal: "", sep_obra_codigo: "",
          sep_obra_cib: "", sep_obra_end_cep: "", sep_obra_end_logradouro: "",
          sep_obra_end_bairro: "", sep_obra_end_numero: "", sep_obra_end_complemento: "",
        },
      },
      valores: {
        sep_valor: 0, sep_iss: 0, sep_deducoes: 0, sep_aliquota: 0,
        sep_desconto_incondicionado: 0, sep_desconto_condicionado: 0,
        sep_iss_retido: 'N', sep_responsavel_retencao: null,
        sep_inss: 0, sep_ir: 0, sep_pis: 0, sep_csll: 0, sep_cofins: 0,
        sep_outras_retencoes: 0, sep_base_inss_mensal: 0, sep_aliquota_base_inss: 100,
        sep_inss_externo: 0, sep_base_iva: 0,
        sep_aliquota_reducao_ibs: 0, sep_aliquota_reducao_cbs: 0,
        sep_aliquota_ibs: 0.1, sep_valor_ibs: 0, sep_aliquota_cbs: 0.9, sep_valor_cbs: 0,
        sep_aliquota_ibs_aplicada: 0, sep_aliquota_cbs_aplicada: 0,
      },
      competencia: {
        mes: moment().format('M').padStart(2, '0'),
        ano: moment().format('YYYY'),
      },
      verificaAliquota: {
        isMei: false, isSimples: false, isDemaisEmpresas: false,
        desabilitaAliquota: false, aliquotaZerada: false,
      },
      verificaTributacao: {
        disableTributacao: false, disableForaMunicipio: true, disableImune: true,
      },
      verificaDeducao: {ativo: false},
      verificaRenetencao: {ativo: false, reter: false},
      inss_avulso: {base_calculo_mensal: 0, aliquota: 11, ja_retido: 0, teto: 0},
      irrf_avulso: {
        ja_retido: 0, base_calculo_mensal: 0, base_nota_porcetagem: 100,
        qt_dependente: 0, deducao_dependente: 0, base_acumulado: 0,
        aliquota: 11, bruto: 0, parc_dedutiva: 0, valor_desta: 0,
      },
      descricaoFavoritaDados: {dsf_codigo: null, lista: []},
      aliquota: 0,
      errorCepTomador: false,
      errorCepObra: false,
      valorLiquidoZerado: false,
      valorISSNegativo: false,
      valorLiquidoNegativo: false,
      submitted: false,
    };
  },
  computed: {
    entidade() {
      return this.$store.state.auth.currentEntidade;
    },
    empresa() {
      return this.$store.state.auth.currenEmpresa || {eco_tributacao: null};
    },
    isEstrangeiro() {
      return this.pais_tomador.pais !== 'BR';
    },
    sep_competencia() {
      return (this.competencia.mes && this.competencia.ano)
          ? `${this.competencia.mes}/${this.competencia.ano}` : '';
    },
    sep_competencia_data() {
      return (this.competencia.mes && this.competencia.ano)
          ? `${this.competencia.ano}-${this.competencia.mes}-01` : '';
    },
    sep_iss() {
      return (((this.valores.sep_valor - this.valores.sep_deducoes) - this.valores.sep_desconto_incondicionado) * this.valores.sep_aliquota) / 100;
    },
    retencao_federal() {
      return Number(this.valores.sep_inss || 0) + Number(this.valores.sep_ir || 0) + Number(this.valores.sep_pis || 0) +
          Number(this.valores.sep_csll || 0) + Number(this.valores.sep_cofins || 0) + Number(this.valores.sep_outras_retencoes || 0);
    },
    valor_liquido() {
      const iss_retido = (this.valores.sep_iss_retido === 'S') ? Number(this.sep_iss || 0) : 0;
      return Number(this.valores.sep_valor || 0) - (iss_retido + Number(this.valores.sep_desconto_incondicionado || 0) +
          Number(this.valores.sep_desconto_condicionado || 0) + this.retencao_federal);
    },
    inss_base_acumulado() {
      return ((Number(this.valores.sep_valor || 0) * Number(this.valores.sep_aliquota_base_inss || 0)) / 100) + Number(this.valores.sep_base_inss_mensal || 0);
    },
    inss_mensal() {
      return (this.inss_base_acumulado * this.inss_avulso.aliquota) / 100;
    },
    inss_ja_retido() {
      return this.inss_avulso.ja_retido;
    },
    inss_valor_desta() {
      const valor = this.inss_mensal - (this.inss_ja_retido + this.valores.sep_inss_externo);
      return (valor > 0 && this.isAvulso && this.isTomadorCNPJ) ? valor : 0;
    },
    telefoneValido() {
      const tel = this.tomador.sep_telefone_tomador;
      if (!tel) return null;
      return validarTelefoneBR(tel);
    },
    emailValido() {
      const email = this.tomador.sep_email_tomador;
      if (!email) return null;
      return validarEmail(email);
    },
    // Objetos de validação para subcomponentes
    tomadorValidation() {
      const v = this.$v?.tomador;
      if (!v) return {};
      return {
        cpfCnpj: v.sep_cpf_cnpj_tomador?.$error,
        razaoSocial: v.sep_razao_social_tomador?.$error,
        cep: v.sep_cep_tomador?.$error,
        endereco: v.sep_endereco_tomador?.$error,
        numero: v.sep_numero_endereco_tomador?.$error,
        bairro: v.sep_bairro_tomador?.$error,
        complemento: v.sep_complemento_endereco_tomador?.$error,
      };
    },
    servicoValidation() {
      const v = this.$v;
      if (!v) return {};
      return {
        mes: v.competencia?.mes?.$error,
        ano: v.competencia?.ano?.$error,
        serCodigo: v.servico?.ser_codigo?.$error,
        discriminacao: v.servico?.sep_discriminacao?.$error,
        nbsCodigo: v.servico?.nbs_codigo?.$error,
        ranNumero: v.servico?.ran_numero?.$error,
        ranEmissao: v.servico?.ran_nota_emissao?.$error,
        ranNsu: v.servico?.ran_not_nsu?.$error,
        obraTipo: v.servico?.obra?.sep_obra_tipo?.$error,
        obraCodigo: v.servico?.obra?.sep_obra_codigo?.$error,
        obraCib: v.servico?.obra?.sep_obra_cib?.$error,
        obraCep: v.servico?.obra?.sep_obra_end_cep?.$error,
        obraLogradouro: v.servico?.obra?.sep_obra_end_logradouro?.$error,
        obraNumero: v.servico?.obra?.sep_obra_end_numero?.$error,
        obraBairro: v.servico?.obra?.sep_obra_end_bairro?.$error,
      };
    },
    valoresValidation() {
      const v = this.$v?.valores;
      if (!v) return {};
      return {
        valor: v.sep_valor?.$error,
        aliquota: v.sep_aliquota?.$error,
      };
    },
    temValorNegativo() {
      return Object.values(this.valores).some(
          v => typeof v === 'number' && v < 0
      );
    },
    // Computed único para recalcular IVA — substitui 5 watchers
    ivaInputs() {
      return [
        this.valores.sep_valor, this.valores.sep_desconto_incondicionado,
        this.valores.sep_pis, this.valores.sep_cofins, this.sep_iss,
      ];
    },
  },
  watch: {
    'servico.cst_classtrib'(val) {
      if (val) {
        this.valores.sep_aliquota_reducao_cbs = Number(val.cst_perc_red_cbs);
        this.valores.sep_aliquota_reducao_ibs = Number(val.cst_perc_red_ibs);
      }
    },
    // Watcher único: recalcula IVA quando qualquer input muda
    ivaInputs() {
      this.valores.sep_iss = this.sep_iss;
      this.calculoIVA();
    },
    inss_valor_desta(val) {
      this.valores.sep_inss = val;
    },
  },
  validations: {
    tomador: {
      sep_cpf_cnpj_tomador: {required},
      sep_razao_social_tomador: {required, maxLength: maxLength(150)},
      sep_cep_tomador: {required},
      sep_endereco_tomador: {required, maxLength: maxLength(255)},
      sep_numero_endereco_tomador: {required, maxLength: maxLength(10)},
      sep_bairro_tomador: {required, maxLength: maxLength(60)},
      sep_complemento_endereco_tomador: {maxLength: maxLength(60)},
    },
    competencia: {
      mes: {required},
      ano: {required, minLength: minLength(4), maxLength: maxLength(4)},
    },
    servico: {
      sep_municipio_incidencia: {required},
      sep_municipio_prestacao: {required},
      ran_numero: {
        required: requiredIf(function () {
          return this.ranfs;
        })
      },
      ran_nota_emissao: {
        required: requiredIf(function () {
          return this.ranfs;
        })
      },
      ran_not_nsu: {
        required: requiredIf(function () {
          return this.ranfs;
        })
      },
      ser_codigo: {required},
      sep_discriminacao: {required},
      nbs_codigo: {
        required: requiredIf(function (val) {
          return val.ser_codigo.ser_nbs_obrigatorio === 'S';
        }),
      },
      obra: {
        sep_obra_tipo: {
          required: requiredIf(function () {
            return this.isObra;
          })
        },
        sep_obra_codigo: {
          required: requiredIf(function () {
            return this.isObra && this.servico.obra.sep_obra_tipo === 1;
          })
        },
        sep_obra_cib: {
          required: requiredIf(function () {
            return this.isObra && this.servico.obra.sep_obra_tipo === 2;
          })
        },
        sep_obra_end_cep: {
          required: requiredIf(function () {
            return this.isObra && this.servico.obra.sep_obra_tipo === 3;
          })
        },
        sep_obra_end_logradouro: {
          required: requiredIf(function () {
            return this.isObra && this.servico.obra.sep_obra_tipo === 3;
          }),
          maxLength: maxLength(255),
        },
        sep_obra_end_bairro: {
          required: requiredIf(function () {
            return this.isObra && this.servico.obra.sep_obra_tipo === 3;
          }),
          maxLength: maxLength(60),
        },
        sep_obra_end_numero: {
          required: requiredIf(function () {
            return this.isObra && this.servico.obra.sep_obra_tipo === 3;
          }),
          maxLength: maxLength(60),
        },
      },
    },
    valores: {
      sep_valor: {required, minValue: minValue(0.01)},
      sep_aliquota: {required, minValue: minValue(2.00), maxValue: maxValue(5.00)},
    },
  },
  async created() {
    if (this.entidade) {
      this.municipioPadrao();
      this.servico.sep_municipio_prestacao.mun_codigo = this.entidade.mun_codigo;
      this.servico.sep_municipio_prestacao.mun_nome = this.entidade.mun_nome;
      this.servico.sep_municipio_prestacao.mun_uf = this.entidade.mun_uf;
      this.alter_ano();
    }
    if (this.ranfs) {
      this.verificaTributacao.disableTributacao = true;
    } else {
      let statusEmpresa = parseInt(this.empresa.tab_107situacao);
      if (statusEmpresa !== 1003) {
        notifyErro("Impossível emitir NFS-e", "A empresa possui pendências cadastrais ou fiscais. Procurar o setor tributário ou de finanças do município");
        await this.$router.push({name: 'painel'});
      }
      let tipoEmpresa = parseInt(this.empresa.pes_tipopessoa);
      if (tipoEmpresa === 2) {
        this.isAvulso = true;
      }
      if (tipoEmpresa === 4) {
        notifyErro("Impossível emitir NFS-e", "Esta empresa não tem permissão para a utilização deste recurso");
        await this.$router.push({name: 'painel'});
      } else {
        this.httpSend = true;
        await this.atividadeCnae();
        this.httpSend = false;
      }
      if (this.entidade) {
        const mun_entidade = parseInt(this.entidade.mun_codigo);
        const mun_empresa = parseInt(this.empresa.mun_codigo);
        if (mun_empresa !== mun_entidade) {
          notifyErro("Impossível emitir NFS-e", "Empresa com endereço comercial em outro município");
          await this.$router.push({name: 'painel'});
        }
      }
      if (this.isAvulso && this.isTomadorCNPJ) {
        this.baseMensal();
      }
      if (this.substituicao) {
        this.substituindo.not_hash = this.$route.params.not_hash;
        this.notaFiscal(this.$route.params.not_hash);
      }
    }
  },
  methods: {
    round,

    // ======================== API / Dados ========================
    notaFiscal(not_hash) {
      this.httpSend = true;
      getNotaFiscal(not_hash, {eco_codigo: this.empresa.eco_codigo}).then(async result => {
        if (result.status) {
          await this.populaNotaFiscal(result.dados);
          this.closeModalCopiar();
        } else {
          notifyErro("Erro Interno", result.mensagem);
          this.$router.push({name: 'contribuinte-nota-fiscal-lista'});
        }
      }).catch(console.error).finally(() => {
        this.httpSend = false;
      });
    },

    pesquisarUltimaNotas(filtro) {
      this.httpSendPesquisaCopyNota = true;
      const f = filtro || this.copyNota.filtro;
      listNotas(this.empresa.eco_codigo, f).then(result => {
        if (result.status) {
          this.$refs.modalCopiarNota?.setResultado(result.dados.notas);
        }
      }).catch(console.error).finally(() => {
        this.httpSendPesquisaCopyNota = false;
      });
    },

    locCEP(cep) {
      if (!cep) return;
      this.httpSend = true;
      this.errorCepTomador = false;
      getCEP(cep).then(result => {
        if (result.status === 200) {
          if (Object.prototype.hasOwnProperty.call(result.data, 'erro')) {
            this.$refs.tabTomadorRef?.focusCep();
            this.errorCepTomador = true;
            this.tomador.mun_uf = '';
            this.tomador.mun_nome = '';
            this.tomador.sep_municipio_tomador = null;
            this.tomador.sep_bairro_tomador = '';
            this.tomador.sep_endereco_tomador = '';
          } else {
            this.errorCepTomador = false;
            this.tomador.mun_uf = result.data.uf;
            this.tomador.mun_nome = result.data.localidade;
            this.tomador.sep_municipio_tomador = result.data.ibge;
            this.tomador.sep_bairro_tomador = result.data.bairro;
            this.tomador.sep_endereco_tomador = result.data.logradouro;
            if (this.tomador.sep_endereco_tomador) {
              this.$refs.tabTomadorRef?.focusNumero();
            } else {
              this.$refs.tabTomadorRef?.focusEndereco();
            }
          }
        }
      }).catch(error => {
        this.errorCepTomador = true;
        this.tomador.mun_uf = '';
        this.tomador.mun_nome = '';
        this.tomador.sep_municipio_tomador = null;
        console.error(error);
      }).finally(() => {
        this.httpSend = false;
      });
    },

    locObra(cep) {
      if (!cep) return;
      this.httpSend = true;
      this.errorCepObra = false;
      getCEP(cep).then(result => {
        if (result.status === 200) {
          if (Object.prototype.hasOwnProperty.call(result.data, 'erro')) {
            this.$refs.tabServicosRef?.focusObraCep();
            this.errorCepObra = true;
            this.servico.obra.sep_obra_end_bairro = '';
            this.servico.obra.sep_obra_end_logradouro = '';
          } else {
            this.errorCepObra = false;
            this.servico.obra.sep_obra_end_bairro = result.data.bairro;
            this.servico.obra.sep_obra_end_logradouro = result.data.logradouro;
            if (this.servico.obra.sep_obra_end_logradouro) {
              this.$refs.tabServicosRef?.focusObraNumero();
            } else {
              this.$refs.tabServicosRef?.focusObraLogradouro();
            }
          }
        }
      }).catch(error => {
        this.errorCepObra = true;
        console.error(error);
      }).finally(() => {
        this.httpSend = false;
      });
    },

    locTomador(cpf_cnpj) {
      if (!cpf_cnpj) return;
      if (!validaCpfCnpj(cpf_cnpj)) {
        this.cpfCnpjInvalid = true;
        return;
      }
      if (this.empresa.pes_cpfcnpj === cpf_cnpj) {
        this.tomadorIsPrestador = true;
        return;
      }
      this.cpfCnpjInvalid = false;
      this.tomadorIsPrestador = false;
      this.ranfs ? this.locTomadorRanfs(cpf_cnpj) : this.locTomadorNota(cpf_cnpj);
    },

    locTomadorNota(sep_cpf_cnpj_tomador) {
      this.httpSend = true;
      getTomador({eco_codigo: this.empresa.eco_codigo, cpf_cnpj: sep_cpf_cnpj_tomador}).then(async result => {
        if (result.status) {
          this.tomador = result.dados;
          this.isTomadorCNPJ = isCnpj(this.tomador.sep_cpf_cnpj_tomador);
          if (this.tomador.sep_municipio_tomador === "" && this.isTomadorCNPJ) {
            await this.locTomadorWeb();
          }
        }
      }).catch(console.error).finally(() => {
        this.httpSend = false;
      });
    },

    locTomadorRanfs(cpf_cnpj_prestador) {
      this.httpSend = true;
      getPrestador({cpf_cnpj: cpf_cnpj_prestador}).then(async result => {
        if (result.status) {
          this.tomador = result.dados;
        } else {
          this.isTomadorCNPJ = isCnpj(cpf_cnpj_prestador);
          if (this.isTomadorCNPJ) await this.locTomadorWeb();
        }
      }).catch(console.error).finally(() => {
        this.httpSend = false;
      });
    },

    async locTomadorWeb() {
      await nextTick();
      return new Promise(resolve => {
        this.httpSend = true;
        locEmpresa(this.tomador.sep_cpf_cnpj_tomador).then(result => {
          if (Object.prototype.hasOwnProperty.call(result.data, 'cnpj_raiz')) {
            const e = result.data;
            this.tomador.sep_razao_social_tomador = e.razao_social;
            this.tomador.sep_telefone_tomador = e.estabelecimento.ddd1 + e.estabelecimento.telefone1;
            this.tomador.sep_email_tomador = e.estabelecimento.email;
            this.tomador.sep_cep_tomador = e.estabelecimento.cep;
            this.tomador.mun_nome = e.estabelecimento.cidade.nome;
            this.tomador.mun_uf = e.estabelecimento.estado.sigla;
            this.tomador.sep_endereco_tomador = e.estabelecimento.tipo_logradouro + " " + e.estabelecimento.logradouro;
            this.tomador.sep_numero_endereco_tomador = e.estabelecimento.numero;
            this.tomador.sep_bairro_tomador = e.estabelecimento.bairro;
            this.tomador.sep_complemento_endereco_tomador = String(e.estabelecimento.complemento).replace(/\s{2,}/g, ' ');
            this.tomador.sep_municipio_tomador = e.estabelecimento.cidade.ibge_id;
            resolve(true);
          } else {
            resolve(false);
          }
        }).catch(error => {
          resolve(false);
          console.error(error);
        })
            .finally(() => {
              this.httpSend = false;
            });
      });
    },

    atividadeCnae() {
      return new Promise(resolve => {
        getAtividadeCnae(this.empresa).then(result => {
          if (result.status) {
            this.copyNota.ultima_nota = result.dados.ultima_nota;
            this.list_atividades = result.dados.atividade;
            if (this.list_atividades.length < 1) {
              notifyErro("Impossível emitir NFS-e", "Empresa não possui atividade cadastrada. Entre em contato com a Prefeitura");
            }
            this.list_cnae = result.dados.cnae;
          }
          resolve(true);
        }).catch(console.error).finally(() => {
          this.httpSend = false;
        });
      });
    },

    pesquisarCnaeRanfs(search) {
      if (search && search.length > 1) {
        autocompleteCnae({query: search}).then(response => {
          if (response.status) this.list_cnae = response.dados;
        }).catch(console.error);
      }
    },

    async listaComplementoServico() {
      await nextTick();
      return new Promise(resolve => {
        getComplementoServico(this.servico.ser_codigo).then(result => {
          if (result.status) {
            this.list_nbs = result.dados.nbs;
            this.list_operacao = result.dados.operacao;
            this.list_classificao = result.dados.classificao;
          }
          resolve(true);
        }).catch(console.error).finally(() => {
          this.httpSend = false;
        });
      });
    },

    pesquisarServicosRanfs(search) {
      if (search && search.length > 1) {
        autocompleteServicos({query: search}).then(response => {
          if (response.status) this.list_atividades = response.dados;
        }).catch(console.error);
      }
    },

    async verificaOptanteSimplesNacional() {
      await nextTick();
      return new Promise(resolve => {
        this.servico.sep_data_tributacao = moment().format('YYYY-MM-DD');
        const nota_na_competencia = naCompetencia(this.servico.sep_data_tributacao, this.sep_competencia_data);
        if (this.substituicao || !nota_na_competencia) {
          this.servico.sep_data_tributacao = getFimMesDate(this.sep_competencia_data);
        }
        this.httpSend = true;
        const dados = {
          eco_codigo: this.empresa.eco_codigo,
          data_tributacao: this.servico.sep_data_tributacao,
          ser_codigo: this.servico.ser_codigo.ser_codigo,
        };
        getNotaFiscalTributacaoSimples(dados).then(result => {
          resolve(result.status ? result.dados : false);
        }).catch(error => {
          resolve(false);
          console.error(error);
        })
            .finally(() => {
              this.httpSend = false;
            });
      });
    },

    // ======================== Validações de Tab ========================
    validaTabTomador() {
      this.$v.$touch();
      this.submitted = true;
      if (this.$v.tomador.$invalid && !this.isEstrangeiro) return false;

      if (this.telefoneValido === false) return false;
      if (this.emailValido === false) return false;

      if (!this.isEstrangeiro) {
        if (!validaCpfCnpj(this.tomador.sep_cpf_cnpj_tomador)) {
          this.cpfCnpjInvalid = true;
          notifyErro("Impossível emitir NFS-e", "Verifique o CPF ou CNPJ do tomador");
          return false;
        }
        if (this.empresa.pes_cpfcnpj === this.tomador.sep_cpf_cnpj_tomador) {
          this.tomadorIsPrestador = true;
          notifyErro("Impossível emitir NFS-e", "CPF ou CNPJ do tomador não pode ser idêntico ao do Prestador");
          return false;
        }
        if (!this.tomador.sep_municipio_tomador) {
          notifyErro("Impossível emitir NFS-e", "Verifique se o CEP foi digitado corretamente. Não utilize o autocompletar do navegador");
          return false;
        }
      } else {
        if (!this.tomador.pas_codigo) {
          notifyErro("Impossível emitir NFS-e", "Verifique se o país foi selecionado corretamente");
          return false;
        }
        if (this.tomador.sep_razao_social_tomador === '') {
          this.pais_tomador.erro_razao_social = true;
          return false;
        }
        if (this.tomador.sep_endereco_tomador === '') {
          this.pais_tomador.erro_endereco = true;
          return false;
        }
      }
      window.scrollTo(0, 0);
      this.verificaDeducao.ativo = false;
      this.verificaRenetencao.reter = false;
      this.verificaRenetencao.ativo = false;
      if (!this.substituicao) {
        this.valores.sep_iss_retido = 'N';
        this.valores.sep_responsavel_retencao = null;
      }
      return true;
    },

    async validaTabServico() {
      await nextTick();
      this.$v.$touch();
      /*
      if (this.servico.sep_tributacao_iss === '2' && !this.isAvulso) {
        if (this.servico.ser_codigo) {
          if (this.servico.sep_municipio_incidencia.mun_codigo === this.entidade.mun_codigo) {
            notifyErro("Impossível emitir NFS-e", "Município de tributação deve ser diferente de " + this.entidade.mun_nome + '/' + this.entidade.mun_uf);
            return false;
          }
        }
      }*/
      if (this.$v.competencia.$invalid || this.$v.servico.$invalid) return false;

      const aux_tributacao = await this.verificaOptanteSimplesNacional();
      if (!aux_tributacao) {
        notifyErro("Impossível emitir NFS-e", "Não foi possível verificar a tributação da empresa ou alíquota do serviço. Entre em contato com o suporte da nota fiscal");
        return false;
      }

      //Validação da Incidencia
      const ser_incidencia = this.servico.ser_codigo.ser_incidencia;
      const sep_municipio_incidencia = this.servico.sep_municipio_incidencia.mun_codigo;
      const sep_municipio_prestacao = this.servico.sep_municipio_prestacao.mun_codigo;

      if (ser_incidencia === 'EP') {
        const municipio_prestador = this.empresa.mun_codigo;
        if (sep_municipio_incidencia !== municipio_prestador) {
          notifyErro(
              "Impossível emitir NFS-e",
              "O município de tributação do ISS deve ser o mesmo do domicílio do prestador do serviço."
          );
          return false;
        }
      }

      if (ser_incidencia === 'LP') {
        if (sep_municipio_incidencia !== sep_municipio_prestacao) {
          notifyErro(
              "Impossível emitir NFS-e",
              "O município de tributação do ISS deve ser o mesmo onde o serviço foi prestado."
          );
          return false;
        }
      }

      if (ser_incidencia === 'ET') {
        if (sep_municipio_incidencia !== this.tomador.sep_municipio_tomador) {
          notifyErro(
              "Impossível emitir NFS-e",
              "O município de tributação do ISS deve ser o mesmo do domicílio do tomador do serviço."
          );
          return false;
        }
      }

      const tributacao = parseInt(aux_tributacao.tributacao.eco_tributacao);
      const aliquota = parseFloat(aux_tributacao.aliquota.sea_aliquota);
      const temp_empresa = JSON.parse(JSON.stringify(this.empresa));
      temp_empresa.eco_tributacao = tributacao;
      await store.dispatch('auth/empresa', temp_empresa);
      this.verificaAliquota = {
        isMei: false,
        isSimples: false,
        isDemaisEmpresas: false,
        desabilitaAliquota: false,
        aliquotaZerada: false
      };
      this.valores.sep_aliquota = aliquota;
      this.verificaDeducao.ativo = false;

      if (this.servico.sep_municipio_incidencia.mun_codigo === this.entidade.mun_codigo) {
        if (this.servico.ser_codigo.ser_deducao_municipio === 'S') this.verificaDeducao.ativo = true;
      } else {
        if (this.servico.ser_codigo.ser_deducao_demais === 'S') this.verificaDeducao.ativo = true;
      }

      if (tributacao === 1) {
        this.verificaAliquota.isMei = true;
        this.verificaAliquota.desabilitaAliquota = true;
      }
      if (tributacao === 2) {
        this.verificaAliquota.isSimples = true;
      }
      if (tributacao > 2) {
        this.verificaAliquota.isDemaisEmpresas = true;
        this.verificaAliquota.desabilitaAliquota = !(this.servico.ser_codigo.ser_retencao === 'S' && this.servico.sep_municipio_incidencia.mun_codigo !== this.entidade.mun_codigo);
      }

      if (tributacao === 1) {
        this.valores.sep_aliquota = 0;
        this.verificaAliquota.aliquotaZerada = true;
      } else {
        if (aliquota < 0.01) this.verificaAliquota.aliquotaZerada = true;
      }

      const tomador_controle = {
        isSubstituto: false, isCadastrado: false,
        sede_municipio: this.tomador.sep_municipio_tomador === this.entidade.mun_codigo,
        isPj: isCnpj(this.tomador.sep_cpf_cnpj_tomador),
      };
      if (this.tomador.eco_codigo) {
        tomador_controle.isCadastrado = true;
        tomador_controle.isSubstituto = this.tomador.eco_substituicao === 'S';
      }

      if (this.servico.ser_codigo.ser_retencao === 'S') {
        if (this.servico.sep_municipio_incidencia.mun_codigo === this.entidade.mun_codigo) {
          if (tomador_controle.isCadastrado && tomador_controle.isPj && tomador_controle.sede_municipio && !this.verificaAliquota.isMei) {
            this.verificaRenetencao.ativo = true;
            this.verificaRenetencao.reter = false;
          }
        } else {
          this.verificaRenetencao.ativo = true;
          this.verificaRenetencao.reter = false;
        }
      }

      if (tomador_controle.isSubstituto && tomador_controle.sede_municipio && !this.isAvulso) {
        if (this.verificaAliquota.isDemaisEmpresas) {
          this.verificaRenetencao.ativo = false;
          this.verificaRenetencao.reter = true;
        }
        if (this.verificaAliquota.isSimples) {
          this.verificaRenetencao.ativo = true;
          this.verificaRenetencao.reter = false;
        }
      }

      if (this.verificaRenetencao.reter) {
        this.valores.sep_iss_retido = 'S';
        this.valores.sep_responsavel_retencao = '1';
      }
      if (this.cnae_aux) this.servico.cnae_codigo = this.cnae_aux;

      if (this.isAvulso) {
        this.verificaAliquota.desabilitaAliquota = true;
        this.verificaRenetencao.ativo = false;
        this.verificaRenetencao.reter = false;
        this.valores.sep_iss_retido = 'N';
      }
      if (this.isAvulso && tomador_controle.isPj) this.baseMensal();

      if (this.ranfs) {
        this.valores.sep_iss_retido = 'S';
        this.valores.sep_responsavel_retencao = '1';
        if (parseInt(this.servico.sep_municipio_incidencia.mun_codigo) !== parseInt(this.entidade.mun_codigo)) {
          this.verificaAliquota.desabilitaAliquota = false;
        }
      }

      this.calculoIVA();
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 300);
      return true;
    },

    validaTabValores() {
      this.valorLiquidoNegativo = false;
      this.valorISSNegativo = false;
      if (!this.verificaAliquota.aliquotaZerada) {
        this.$v.$touch();
        if (this.$v.valores.$invalid) return false;
        if (this.sep_iss < 0) {
          this.valorISSNegativo = true;
          return false;
        }
      }
      if (this.valor_liquido < 0.01) {
        this.valorLiquidoNegativo = true;
        return false;
      }
      if (this.verificaAliquota.isDemaisEmpresas && !this.verificaAliquota.aliquotaZerada) {
        if (this.valores.sep_aliquota < 0.01) return false;
      }

      if (this.temValorNegativo) {
        notifyErro(
            "Impossível emitir NFS-e",
            "Os campos não podem ter valor negativo. Corrija antes de prosseguir."
        );
        return false;
      }

      window.scrollTo(0, 0);
      return true;
    },

    // ======================== Cálculos ========================
    calculoIVA() {
      if (this.valores.sep_aliquota_reducao_ibs === undefined) this.valores.sep_aliquota_reducao_ibs = 0;
      if (this.valores.sep_aliquota_reducao_cbs === undefined) this.valores.sep_aliquota_reducao_cbs = 0;
      this.valores.sep_base_iva = this.valores.sep_valor - (this.valores.sep_desconto_incondicionado + this.valores.sep_deducoes + this.valores.sep_iss + this.valores.sep_pis + this.valores.sep_cofins);
      this.valores.sep_aliquota_ibs_aplicada = round(this.valores.sep_aliquota_ibs * (1 - (this.valores.sep_aliquota_reducao_ibs / 100)), 2);
      this.valores.sep_aliquota_cbs_aplicada = round(this.valores.sep_aliquota_cbs * (1 - (this.valores.sep_aliquota_reducao_cbs / 100)), 2);
      this.valores.sep_valor_ibs = (this.valores.sep_base_iva * this.valores.sep_aliquota_ibs_aplicada) / 100;
      this.valores.sep_valor_cbs = (this.valores.sep_base_iva * this.valores.sep_aliquota_cbs_aplicada) / 100;
    },

    // ======================== Emissão ========================
    confirmacao(nota_rascunho) {
      if (nota_rascunho === 1) {
        this.enviaNota(nota_rascunho);
        return;
      }
      let texto = this.substituicao
          ? "Confirma a emissão da nota fiscal em substituição à nota fiscal n° " + this.substituindo.not_numero + " ?"
          : "Confirma a emissão da nota fiscal?";
      Swal.fire({
        title: texto, text: "", icon: "question", showCancelButton: true,
        confirmButtonColor: "#34c38f", cancelButtonColor: "#100e0e",
        confirmButtonText: "Sim", cancelButtonText: "Não",
      }).then(result => {
        if (result.isConfirmed) this.enviaNota(nota_rascunho);
      });
    },

    confirmacaoAvulsa(nota_rascunho) {
      if (nota_rascunho === 1) {
        this.enviaNotaAvulsa(nota_rascunho);
        return;
      }
      Swal.fire({
        title: "Deseja emitir nota fiscal avulsa?",
        text: "A nota fiscal avulsa será emitida somente após o pagamento da taxa de emissão.",
        icon: "question", showCancelButton: true,
        confirmButtonColor: "#34c38f", cancelButtonColor: "#100e0e",
        confirmButtonText: "Sim", cancelButtonText: "Não",
      }).then(result => {
        if (result.isConfirmed) this.enviaNotaAvulsa(nota_rascunho);
      });
    },

    confirmacaoRanfs() {
      Swal.fire({
        title: "Deseja emitir a Ranfs?", text: "", icon: "question",
        showCancelButton: true, confirmButtonColor: "#34c38f", cancelButtonColor: "#100e0e",
        confirmButtonText: "Sim", cancelButtonText: "Não",
      }).then(result => {
        if (result.isConfirmed) this.enviaRanfs();
      });
    },

    enviaNota(nota_rascunho) {
      this.httpSend = true;
      const dados = {
        nota_rascunho, substituindo: this.substituindo, empresa: this.empresa,
        tomador: this.tomador, competencia: this.competencia,
        servico: this.servico, valores: this.valores,
      };
      dados.valores.sep_iss = arredondamento(dados.valores.sep_iss);
      dados.valores.sep_base_iva = arredondamento(dados.valores.sep_base_iva);
      gerarNota({dados}).then(response => {
        if (response.status) {
          notifySucesso("DattaNFSe", response.mensagem);
          this.visualiza_nota(response.dados);
          this.nota_envia_email(response.dados);
        } else {
          notifyErro("Erro ao emitir Nota Fiscal", response.mensagem);
        }
      }).catch(error => {
        notifyErro("Erro Interno", error);
      }).finally(() => {
        this.httpSend = false;
      });
    },
    enviaNotaAvulsa(nota_rascunho) {
      this.httpSend = true;
      const dados = {
        nota_rascunho, substituindo: this.substituindo, empresa: this.empresa,
        tomador: this.tomador, competencia: this.competencia,
        servico: this.servico, valores: this.valores,
      };
      dados.valores.sep_iss = arredondamento(dados.valores.sep_iss);
      dados.valores.sep_base_iva = arredondamento(dados.valores.sep_base_iva);
      gerarNotaAvulsa({dados}).then(response => {
        if (response.status) {
          notifySucesso("DattaNFSe", response.mensagem);
          const dam = response.dados;
          if (dam.hasOwnProperty('not_hash')) {
            this.visualiza_nota(dam);
          } else {
            this.$router.push({name: 'contribuinte-financeiro-pagamento', params: {dam_hash: dam.dam_hash}});
          }
        } else {
          notifyErro("Erro Interno", response.mensagem);
        }
      }).catch(error => {
        notifyErro("Erro Interno", error);
      })
          .finally(() => {
            this.httpSend = false;
          });
    },

    enviaRanfs() {
      this.httpSend = true;
      const dados = {
        eco_codigo: this.empresa.eco_codigo, prestador: this.tomador,
        competencia: this.competencia, servico: this.servico, valores: this.valores,
      };
      dados.valores.sep_iss = arredondamento(dados.valores.sep_iss);
      solicitarRanfs({dados}).then(response => {
        if (response.status) {
          notifySucesso("Ranfs", response.mensagem);
          this.visualiza_ranfs(response.dados);
        } else {
          notifyErro("Erro", response.mensagem);
        }
      }).catch(error => {
        notifyErro("Erro", error);
      })
          .finally(() => {
            this.httpSend = false;
          });
    },

    nota_envia_email(nota) {
      getEnviaEmailNotaFiscal(nota.not_hash).then(result => {
        if (result.status) notifySucesso("DattaNFSe", result.mensagem);
        else notifyErro("DattaNFSe", result.mensagem);
      }).catch(console.error);
    },

    visualiza_nota(nota) {
      this.$router.push({name: 'contribuinte-nota-fiscal-visualizar', params: {not_hash: nota.not_hash}});
    },

    visualiza_ranfs(ranfs) {
      this.httpSend = true;
      if (isMobile()) {
        impressao(setRelRanfs(ranfs.ran_hash), 'P').catch(console.error)
            .finally(() => {
              this.httpSend = false;
            });
      } else {
        this.$router.push({name: 'contribuinte-ranfs-visualizar', params: {ran_hash: ranfs.ran_hash}});
      }
    },

    // ======================== Atividades / Seleção ========================
    async selctAtividade(selectedOption) {
      await nextTick();
      this.resetaValores();
      this.municipioPadrao();
      await this.listaComplementoServico();
      let retencao = selectedOption.ser_retencao === 'N';

      this.verificaTributacao.disableForaMunicipio = retencao;
      this.verificaTributacao.disableImune = true;
      this.verificaTributacao.disableTributacao = retencao;
      this.servico.sep_exigibilidade_iss = '1';

      if (selectedOption.ser_codigo.startsWith('99')) {
        this.verificaTributacao.disableImune = false;
        this.verificaTributacao.disableTributacao = true;
        this.servico.sep_exigibilidade_iss = '2';
      }
      if (this.isAvulso) {
        this.verificaTributacao.disableForaMunicipio = true;
        this.verificaTributacao.disableImune = true;
        this.verificaTributacao.disableTributacao = true;
        this.servico.sep_exigibilidade_iss = '2';
      }
      if (this.verificaTributacao.disableForaMunicipio) this.servico.sep_tributacao_iss = '1';
      if (this.ranfs) this.verificaTributacao.disableTributacao = true;
      this.verificaSeObra(selectedOption.ser_codigo);
    },

    async populaNotaFiscal(dados) {
      this.tomador = {...dados.tomador};
      this.servico = {...dados.servico};
      this.servico.ser_codigo = this.list_atividades.find(x => x.ser_codigo === dados.servico.ser_codigo);
      if (this.servico.ser_codigo === undefined) {
        this.servico.ser_codigo = this.list_atividades[0];
        notifyAviso("Copiar NFS-e", "A atividade da NFS-e copiada não foi localizada na lista atual de atividades da empresa");
      }
      await this.listaComplementoServico();
      this.cnae_aux = this.servico?.cnae_codigo ? this.list_cnae.find(x => x.cnae_codigo === this.servico.cnae_codigo) : null;
      this.servico.cnae_codigo = this.cnae_aux || "";
      this.servico.nbs_codigo = this.servico?.nbs_codigo ? this.list_nbs.find(x => x.nbs_codigo === this.servico.nbs_codigo) || "" : "";
      this.servico.iop_codigo = this.servico?.iop_codigo ? this.list_operacao.find(x => x.iop_codigo === this.servico.iop_codigo) || "" : "";
      this.servico.cst_classtrib = this.servico?.cst_classtrib ? this.list_classificao.find(x => x.cst_classtrib === this.servico.cst_classtrib) || "" : "";
      this.valores = {...dados.valores};
      this.valores.sep_aliquota_cbs = 0.9;
      this.valores.sep_aliquota_ibs = 0.1;

      if (this.servico.sep_tributacao_iss === '2' || this.servico.ser_codigo.ser_retencao === 'S') {
        this.verificaTributacao.disableForaMunicipio = false;
      }
      if (dados.tomador.pas_codigo) {
        this.tomador.pas_codigo = {pas_codigo: dados.tomador.pas_codigo, pas_nome: dados.tomador.pas_nome};
        this.pais_tomador.pais = 'FORA';
      }
      if (this.substituicao) {
        this.substituindo.not_numero = dados.nota.not_numero;
        const competenciaArray = String(dados.servico.sep_competencia).split('-');
        if (competenciaArray && competenciaArray.length > 0) {
          this.competencia.ano = competenciaArray[0];
          this.competencia.mes = competenciaArray[1];
          this.alter_ano();
        }
      }
      this.verificaSeObra(this.servico.ser_codigo.ser_codigo);
    },

    // ======================== Auxiliares ========================
    resetaValores() {
      this.valores.sep_deducoes = 0;
      this.servico.nbs_codigo = "";
      this.servico.iop_codigo = "";
      this.servico.cst_classtrib = "";
      this.servico.obra.sep_obra_tipo = null;
      this.servico.obra.sep_obra_insc_fiscal = "";
      this.resetaObra();
    },

    selecionaUltimaNota(not_hash) {
      this.notaFiscal(not_hash);
    },

    verificaSeObra(ser_codigo) {
      const servicos_obras = ["0702", "0704", "0705", "0706", "0707", "0708", "0717", "0719"];
      this.isObra = servicos_obras.includes(ser_codigo.slice(0, 4));
    },

    resetaObra() {
      this.servico.obra.sep_obra_codigo = "";
      this.servico.obra.sep_obra_cib = "";
      this.servico.obra.sep_obra_end_cep = "";
      this.servico.obra.sep_obra_end_logradouro = "";
      this.servico.obra.sep_obra_end_bairro = "";
      this.servico.obra.sep_obra_end_numero = "";
      this.servico.obra.sep_obra_end_complemento = "";
    },

    baseMensal() {
      getBaseMensal({eco_codigo: this.empresa.eco_codigo, sep_competencia: this.sep_competencia_data}).then(result => {
        if (result.status) {
          const d = result.dados;
          this.valores.sep_base_inss_mensal = parseFloat(d.inss_base_anterior);
          this.inss_avulso.ja_retido = parseFloat(d.inss_retido_anterior);
          this.inss_avulso.teto = parseFloat(d.teto_previdencia);
          this.valores.sep_inss_externo = parseFloat(d.inss_externo);
        }
      }).catch(console.error).finally(() => {
        this.httpSend = false;
      });
    },

    selctTributacao(selectedOption) {
      if (parseInt(selectedOption) !== 2) {
        this.municipioPadrao();
      }
    },

    alterRentencao(value) {
      this.valores.sep_responsavel_retencao = value === 'S' ? '1' : '0';
    },

    municipioPadrao() {
      this.servico.sep_municipio_incidencia.mun_codigo = this.entidade.mun_codigo;
      this.servico.sep_municipio_incidencia.mun_nome = this.entidade.mun_nome;
      this.servico.sep_municipio_incidencia.mun_uf = this.entidade.mun_uf;
    },

    alter_ano() {
      if (this.competencia.ano.length !== 4) return;
      this.meses = listMeses(this.competencia.ano);
      if (this.meses.length < 1) this.competencia.mes = null;
    },

    onAlterPais(pais) {
      if (pais === 'BR') {
        this.tomador.pas_codigo = null;
        this.tomador.sep_cep_tomador = '';
        this.tomador.sep_inscricao_estadual_tomador = '';
        this.tomador.sep_inscricao_municipal_tomador = '';
        this.tomador.sep_nif_tomador = '';
      }
    },

    // Modais
    openModalCopiar() {
      this.$refs.modalCopiarNota?.show();
    },
    closeModalCopiar() {
      this.$refs.modalCopiarNota?.fechar();
    },
    openModalHistoricoDescricoes() {
      this.$refs.modalDescricoes?.show();
      this.listAllDescricaoFavoritas();
    },

    selecionarDescricaoFavorito(descricao) {
      this.servico.sep_discriminacao = descricao;
    },

    onModalHidden(id) {
      this.$nextTick(() => {
        document.getElementById(id)?.focus();
      });
    },

    // Favoritos
    listAllDescricaoFavoritas() {
      this.httpSendPesquisaCopyNota = true;
      listDescricaoFavorita({eco_codigo: this.empresa.eco_codigo}).then(response => {
        this.descricaoFavoritaDados.lista = response.dados;
      }).catch(error => {
        notifyErro("Erro Interno", error);
      })
          .finally(() => {
            this.httpSendPesquisaCopyNota = false;
          });
    },

    saveDescricaoFavorito() {
      if (this.descricaoFavorito) {
        if (this.servico.sep_discriminacao && this.servico.sep_discriminacao.length > 1) {
          this.httpSendSalvaFavorito = true;
          saveDescricaoFavorita({
            eco_codigo: this.empresa.eco_codigo,
            dsf_descricao: this.servico.sep_discriminacao
          }).then(response => {
            if (response.status) {
              this.descricaoFavoritaDados.dsf_codigo = response.dados;
              notifySucesso("DattaNFSe", response.mensagem);
            } else {
              this.descricaoFavorito = false;
              notifyErro("DattaNFSe", response.mensagem);
            }
          }).catch(error => {
            notifyErro("Erro Interno", error);
          })
              .finally(() => {
                this.httpSendSalvaFavorito = false;
              });
        }
      } else {
        if (this.descricaoFavoritaDados.dsf_codigo) this.deletaDescricaoFavorita(this.descricaoFavoritaDados.dsf_codigo);
      }
    },

    deletaDescricaoFavorita(dsf_codigo) {
      this.httpSendSalvaFavorito = true;
      deleteDescricaoFavorita(this.empresa.eco_codigo, dsf_codigo).then(response => {
        if (response.status) {
          this.listAllDescricaoFavoritas();
          this.descricaoFavoritaDados.dsf_codigo = null;
          notifySucesso("DattaNFSe", response.mensagem);
        } else {
          notifyErro("DattaNFSe", response.mensagem);
        }
      }).catch(error => {
        notifyErro("Erro Interno", error);
      })
          .finally(() => {
            this.httpSendSalvaFavorito = false;
          });
    },

    confirmacaoRemoverFavorito(dsf_codigo) {
      Swal.fire({
        title: "Confirmação", text: "Deseja realmente remover a descrição dos favoritos?",
        icon: "question", showCancelButton: true,
        confirmButtonColor: "#34c38f", cancelButtonColor: "#100e0e",
        confirmButtonText: "Sim", cancelButtonText: "Não",
      }).then(result => {
        if (result.isConfirmed) this.deletaDescricaoFavorita(dsf_codigo);
      });
    },
  },
};
</script>
